"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("../../util");
var global_1 = require("./global");
var FusionClass = (function () {
    function FusionClass(app) {
        this.app = app;
        this._registeredModules = [];
        this.modules = [];
        this.inited = false;
    }
    FusionClass.prototype.init = function (modules) {
        if (modules === void 0) { modules = [
            'CommonModule',
            'TraceModule',
            'DidiBridgeAdapter',
            'didiAdaper',
        ]; }
        if (this.inited || (window.Fusion && window.Fusion.inited)) {
            util_1.globalHandleError('Fusion has been initialized, duplicate initialization is invalid!', this.app);
            return false;
        }
        else {
            window.Fusion = this;
            this.modules = modules;
            this.inited = true;
            this.fetchJSModules();
            return true;
        }
    };
    FusionClass.prototype.invokeNative = function (module, method) {
        var _this = this;
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var globalInstance = global_1.Global.getInstance();
            var callbackId = globalInstance.callbackId;
            for (var i in args) {
                if (typeof args[i] === 'function') {
                    args = args.slice(0, +i + 1);
                    globalInstance.callbacks[callbackId] = args[i];
                    args[i] = callbackId;
                    ++globalInstance.callbackId;
                    break;
                }
            }
            _this._bridgeCall('invokeNative', module, method, args);
        };
    };
    FusionClass.prototype.callbackJS = function (callbackId, args) {
        var globalInstance = global_1.Global.getInstance();
        var callback = globalInstance.callbacks[callbackId];
        if (callback && typeof callback === 'function') {
            callback.apply(null, args);
        }
    };
    FusionClass.prototype.invokeJSMethod = function (module, method, args) {
        var _this = this;
        var newArgs = [];
        var callbackIdRegExp = /^__\${(\d)+}__$/;
        util_1.each(args, function (value) {
            if (callbackIdRegExp.exec(value)) {
                var callbackId_1 = (callbackIdRegExp.exec(value) || [])[1];
                var self_1 = _this;
                var func = function () {
                    var params = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        params[_i] = arguments[_i];
                    }
                    self_1.callbackNative(callbackId_1, params);
                };
                newArgs.push(func);
            }
            else {
                newArgs.push(value);
            }
        });
        if (this.modules.indexOf(module) !== -1) {
            this[method].apply(this, newArgs);
            return;
        }
        var object = this.loadModule(module);
        object[method].apply(null, newArgs);
    };
    FusionClass.prototype.callbackNative = function (callbackId, args) {
        this._bridgeCall('callbackNative', null, callbackId, args);
    };
    FusionClass.prototype.registerModules = function (modules) {
        var _this = this;
        util_1.each(modules, function (moduleData) {
            if (_this.modules.indexOf(moduleData.module) >= 0) {
                util_1.each(moduleData.methods, function (method) {
                    if (!_this[method]) {
                        _this[method] = _this.invokeNative(moduleData.module, method);
                    }
                });
            }
            else {
                _this.registerModule(moduleData.module);
                util_1.each(moduleData.methods, function (method) {
                    var object = _this.loadModule(moduleData.module);
                    object.registerFn(method);
                });
                _this[moduleData.module] = _this.loadModule(moduleData.module);
            }
            _this._registeredModules.push(moduleData);
        });
    };
    FusionClass.prototype.registerModule = function (module) {
        var globalInstance = global_1.Global.getInstance();
        var object = globalInstance.modules[module];
        if (!object) {
            var self_2 = this;
            globalInstance.modules[module] = Object.create({
                registerFn: function (method) {
                    this[method] = self_2.invokeNative(module, method);
                }
            });
        }
    };
    FusionClass.prototype.loadModule = function (module) {
        var globalInstance = global_1.Global.getInstance();
        var object = globalInstance.modules[module];
        if (object) {
            return object;
        }
        this.registerModule(module);
        return globalInstance.modules[module];
    };
    FusionClass.prototype.fetchJSModules = function () {
        if (this.app.system === 'android') {
            if (this.app.isFusion) {
                var message = JSON.stringify({
                    fusion: 'loadJSModules'
                });
                try {
                    var results = window.prompt(message) || '';
                    results = JSON.parse(results);
                    this.registerModules(results);
                }
                catch (e) {
                }
            }
        }
        else {
            var self_3 = this;
            if (window.loadJSModules) {
                window.loadJSModules(function (modules) {
                    self_3.registerModules(modules);
                });
            }
        }
    };
    FusionClass.prototype.setModules = function (modules) {
        this.modules = modules;
    };
    FusionClass.prototype.getModules = function () {
        return this.modules;
    };
    FusionClass.prototype.getRegisteredModules = function () {
        return this._registeredModules;
    };
    FusionClass.prototype._bridgeCall = function (type, module, method, args) {
        var url = "fusion://" + type + "?";
        if (module) {
            url += "module=" + module + "&";
        }
        url += "method=" + method + "&";
        args[0] === null && args.shift();
        var param = args.map(function (arg) {
            return encodeURIComponent(JSON.stringify(arg));
        });
        url += "arguments=%5B" + param + "%5D&";
        url += "origin=" + window.location.hostname;
        var frame = util_1.createFrame(url, 'mfe-webview-util-iframe-fusion');
        setTimeout(function () {
            document.body.removeChild(frame);
        }, 100);
    };
    return FusionClass;
}());
exports.default = FusionClass;
